import { SolanaAuthWizardStepWalletConnect } from './solana-auth-wizard-step-wallet-connect'

export const AuthWizardStepWalletConnect: React.FC = () => (
  <SolanaAuthWizardStepWalletConnect />
)
